module.exports = __webpack_public_path__ + "stylesheets/global_87fe54a5c0107b4fc172744c115dfe83.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/global.less
// module id = x7Q4
// module chunks = 153